<template>
  <div class="product-detail">
    <div class="header">
      <el-container>
        <el-header>
          <Head />
        </el-header>
      </el-container>
    </div>

    <!-- 二级导航栏 -->
    <div class="sub-nav">
      <div class="nav-container">
        <div class="nav-left">
          <div
            class="nav-item dropdown"
            v-for="(menu, index) in productMenus"
            :key="index"
            @mouseenter="handleMenuEnter(index)"
            @mouseleave="handleMenuLeave"
          >
            <span class="nav-title">{{ menu.title }}</span>
            <div class="dropdown-content" v-show="currentIndex === index">
              <div class="product-grid">
                <router-link
                  v-for="product in menu.children"
                  :key="product.id"
                  :to="product.path"
                  class="product-item"
                >
                  <img :src="product.icon" :alt="product.name" />
                  <div class="product-info">
                    <h4>{{ product.name }}</h4>
                    <p>{{ product.description }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-right">
          <router-link
            v-for="link in navLinks.filter(l => !l.path.startsWith('http'))"
            :key="link.path"
            :to="link.path"
            class="nav-link"
          >
            {{ link.name }}
          </router-link>
          <a
            v-for="link in navLinks.filter(l => l.path.startsWith('http'))"
            :key="link.path"
            :href="link.path"
            target="_blank"
            class="nav-link"
          >
            {{ link.name }}
          </a>
        </div>
      </div>
    </div>

    <div class="product-content">
      <div class="product-banner">
        <div class="banner-content">
          <div class="product-info">
            <h4 class="model">YBM800GA</h4>
            <h2 class="title">工业级DTU产品</h2>
            <div class="features">
              <span class="feature-tag">工业级设计</span>
              <span class="feature-tag">安全稳定可靠</span>
              <span class="feature-tag">双看门狗</span>
            </div>
            <p class="description">
              采用稳定可靠的通信模组，支持最高到4G
              Cat.1互传，支持全球运营商网络。产品提供1个RS485标准接口，支持双远程供电，加强防雷设计，安全稳定可靠。
            </p>
          </div>
          <div class="product-image"></div>
        </div>
      </div>
    </div>
    <div class="download-section">
      <h2 class="section-title">资料下载</h2>
      <div class="download-grid">
        <div
          v-for="(item, index) in downloadItems"
          :key="index"
          class="download-card"
          @mouseover="item.isHovered = true"
          @mouseleave="item.isHovered = false"
          @click="handleDownload(item)"
        >
          <div class="icon-wrapper">
            <img
              :src="item.isHovered ? item.hoverIcon : item.icon"
              :alt="item.title"
            />
          </div>
          <div class="card-title">{{ item.title }}</div>
          <div class="download-text">点击下载PDF</div>
        </div>
      </div>
    </div>
    <div></div>
    <div class="footer">
      <v-footer></v-footer>
    </div>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import vFooter from "@/components/footer2.vue";

export default {
  name: "ProductDetail",
  components: {
    Head,
    vFooter,
  },
  data() {
    return {
      currentIndex: null,
      productMenus: [
        {
          title: '智联产品',
          children: [
            {
              id: 1,
              name: 'YBM307GA',
              path: '/product/YBM307DA',
              icon: require('../../../../public/img/internet/image151.png'),
            },
            {
              id: 2,
              name: 'YBM708ELGA',
              path: '/product/YBM708EUGA',
              icon: require('../../../../public/img/internet/image161.png'),
            },
            {
              id: 3,
              name: 'YBM307UWG',
              path: '/product/YBM507JWG',
              icon: require('../../../../public/img/internet/image171.png'),
            },
            {
              id: 4,
              name: 'YB2000B',
              path: '/product/YB200XB',
              icon: require('../../../../public/img/internet/image181.png'),
            },
            {
              id: 5,
              name: 'YG312',
              path: '/product/YG512',
              icon: require('../../../../public/img/internet/image191.png'),
            },
            {
              id: 6,
              name: 'YBM800KS',
              path: '/product/YBM800KS',
              icon: require('../../../../public/img/internet/image201.png'),
            }
            
          ]
        },
        {
          title: 'DTU',
          children: [
          {
              id: 1,
              name: 'YBM307GA',
              path: '/product/YBM307DA',
              icon: require('../../../../public/img/internet/image151.png'),
            },
            {
              id: 2,
              name: 'YBM708ELGA',
              path: '/product/YBM708EUGA',
              icon: require('../../../../public/img/internet/image161.png'),
            }, 
             {
              id: 5,
              name: 'YG312',
              path: '/product/YG512',
              icon: require('../../../../public/img/internet/image191.png'),
            },
            {
              id: 6,
              name: 'YBM800KS',
              path: '/product/YBM800KS',
              icon: require('../../../../public/img/internet/image201.png'),
            }

          ]
        },
        {
          title: '智能网关',
          children: [
          {
              id: 3,
              name: 'YBM307UWG',
              path: '/product/YBM507JWG',
              icon: require('../../../../public/img/internet/image171.png'),
            },
            {
              id: 4,
              name: 'YB2000B',
              path: '/product/YB200XB',
              icon: require('../../../../public/img/internet/image181.png'),
            },
          ]
        }
      ],
      navLinks: [
        { name: "产品详情", path: "/productDetail" },
        { name: "产品参数", path: "/params" },
        { name: "资料下载", path: "/download" },
        { name: "在线购买", path: "https://m.tb.cn/h.hZXfHaXscQFn4yi  " },
      ],
      downloadItems: [
        {
          title: "产品规格书",
          icon: require("../../../../public/img/internet/download1-1.png"),
          hoverIcon: require("../../../../public/img/internet/download1-5.png"),
          // hoverIcon: require('../../../../public/img/internet/doc-icon-hover.png'),
          fileUrl: "/files/product-spec.pdf",
          isHovered: false,
        },
        {
          title: "配置说明书",
          icon: require("../../../../public/img/internet/download1-2.png"),
          hoverIcon: require("../../../../public/img/internet/download1-5.png"),

          fileUrl: "/files/config-manual.pdf",
          isHovered: false,
        },
        {
          title: "配置工具",
          icon: require("../../../../public/img/internet/download1-3.png"),
          hoverIcon: require("../../../../public/img/internet/download1-5.png"),

          fileUrl: "/files/config-tool.zip",
          isHovered: false,
        },
        {
          title: "教程案例",
          icon: require("../../../../public/img/internet/download1-4.png"),
          hoverIcon: require("../../../../public/img/internet/download1-5.png"),

          fileUrl: "/files/tutorials.pdf",
          isHovered: false,
        },
      ],
    };
  },
  methods: {
    handleMenuEnter(index) {
      this.currentIndex = index;
    },
    handleMenuLeave() {
      this.currentIndex = null;
    },
    handleDownload(item) {
      // 创建一个a标签来触发下载
      const link = document.createElement("a");
      link.href = item.fileUrl;
      link.download = item.title;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
<style lang="scss" scoped>
.product-detail {
  width: 100%;
  min-height: 100vh;
  .sub-nav {
    width: 100%;
    height: 64px;
    background: rgba(26, 29, 33, 0.95);
    backdrop-filter: blur(10px);
    position: fixed;
    top: 64px;
    left: 0;
    z-index: 100;
    transition: all 0.3s ease;

    .nav-container {
      max-width: 1400px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }

    .nav-left {
      display: flex;
      gap: 32px;
    }

    .nav-right {
      display: flex;
      gap: 10px;
    }

    .nav-item {
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;

      .nav-title {
        color: #fff;
        font-size: 16px;
        transition: color 0.3s;

        &:hover {
          color: #409eff;
          border: 1px solid blue;
        }
      }
    }

    .dropdown-content {
      position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top:45px; // 头部+二级导航高度
  width: 1350px;
  min-width: unset;
  max-width: 100vw;
  background: #CEDFFF;
  border-radius: 4px;
  padding: 6px 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,0.3);
  opacity: 0.98;
  overflow: visible;
  z-index: 100;
    }

    .product-grid {
      position: relative;
        width: 100px;
        z-index: 1;
    }
    .product-grid
 {
      display: grid;
      grid-template-columns: repeat(6,1fr);
      gap: 20px;
    }

    .product-item {
     display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // 移除会撑满格子的宽度设置，不要设置 width: 100% 或 flex: 1
  min-width: 100px; // 可选，最小宽度
  max-width: 180px; // 可选，最大宽度
  padding: 16px 1px; // 横向内边距可适当缩小
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s;

      &:hover {
        background: rgba(64, 158, 255, 0.1);
      }

      img {
        width: 61px;
        height: 36px;
        margin-right: 16px;
        // border-radius: 4px;
        margin: 0 0 8px 0;

      }

      .product-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        h4 {
          color:#666;
          font-size: 16px;
          margin: 0 0 4px 0;
        }

        p {
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          margin: 0;
        }
      }
    }

    .nav-link {
      color: #fff;
      text-decoration: none;
      font-size: 16px;
      padding: 8px 16px;
      border-radius: 4px;
      transition: all 0.3s;

      &:hover {
        color: white;
        background: blue;
      }

      &.router-link-active {
        color: #409eff;
        background: rgba(64, 158, 255, 0.1);
      }
    }
  }
  .nav-link:nth-child(4) {
    background: blue;
  }
  .product-content {
    background: url("../../../../public/img/internet/主图banner1-1.png")
      no-repeat;
    background-size: 100% 530px;
    width: 100%;
    padding-top: 64px;
    position: relative;
  }

  .product-banner {
    width: 100%;
    min-height: 600px;
    // background: linear-gradient(180deg, #0a0c0f 0%, #1a1d21 100%);
    padding: 60px 0;
  }

  .banner-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }

  .product-info {
    flex: 1;
    max-width: 600px;
    color: #ffffff;

    .model {
      font-size: 24px;
      color: #ffffff;
      margin-bottom: 20px;
      font-weight: normal;
    }

    .title {
      font-size: 48px;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .features {
      display: flex;
      gap: 12px;
      margin-bottom: 30px;

      .feature-tag {
        padding: 8px 16px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        // font-size: 14px;
      }
    }

    .description {
      font-size: 16px;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.8);
      max-width: 520px;
    }
  }

  .product-image {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      height: auto;
    }
  }
}
.model {
  position: absolute;
  top: 170px;
  left: 260px;
}
.title {
  position: absolute;
  top: 200px;
  left: 260px;
}
.features {
  position: absolute;
  top: 280px;
  left: 260px;

  .feature-tag:nth-child(1) {
    font-size: 20px;
    width: 152px;
    height: 44px;
    background: #454545;
    line-height: 44px;
  }
  .feature-tag:nth-child(2) {
    width: 152px;
    height: 44px;
    margin-left: 12px;
    background: #454545;
    line-height: 44px;
    font-size: 20px;
  }
  .feature-tag:nth-child(3) {
    width: 152px;
    height: 44px;
    margin-left: 12px;
    background: #454545;
    line-height: 44px;
    font-size: 20px;
  }
}
.description {
  text-align: left;
  position: absolute;
  top: 380px;
  left: 260px;
}
.imgs {
  margin-top: -254px;
  margin-bottom: 100px;
  .img1 {
    img {
      width: 1400px;
      height: 760px;
    }
  }
  .img2 {
    img {
      width: 1400px;
      height: 560px;
    }
  }
  .img3 {
    img {
      width: 1400px;
      height: 2310px;
    }
  }
}
.download-section {
  padding: 60px 0;
  max-width: 1400px;
  margin: 0 auto;
  margin-top: -240px;
  margin-bottom: 60px;

  .section-title {
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 48px;
    color: #333;
  }

  .download-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
    padding: 0 20px;
    max-width: 1400px;
    margin: 0 auto;

  }

  .download-card {
    background: #fff;
    border-radius: 8px;
    aspect-ratio: 1;
    position: relative;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #E5E7EB;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      border-color: #409eff;

      .download-text {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .icon-wrapper {
      width: 100%;
      height: 60%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0;

      img {
        width: 80px;
        height: 80px;
        transition: all 0.3s ease;
      }
    }

    .card-title {
      font-size: 18px;
      color: #333;
      font-weight: 500;
      margin-top: -16px;
    }

    .download-text {
      color: #409eff;
      font-size: 14px;
      margin-top: 8px;
      opacity: 0;
      transform: translateY(5px);
      transition: all 0.3s ease;
    }

    .free-solution {
      color: #333;
      font-size: 14px;
      margin-top: 8px;
    }
  }
}
</style>
